export function flagEventsCatchupDone(events) {
  events.forEach((event) => {
    event.catchupDone = true;
  });
}
